import React from 'react';

function QuoteText({ content, name, title, className }) {
  return (
    <div className="text-center md:text-left">
      <h4 className={`font-normal md:max-w-md text-20px leading-tight md:text-h4 ${className || ''}`}>{content}</h4>
      <div>
        <h4 className="font-bold uppercase text-16px ">{name}</h4>
        <div className="italic font-medium text-14px">
          <p>{title}</p>
        </div>
      </div>
    </div>
  );
}

export default QuoteText;
